const ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

const SPLITSCREEN_TYPE = {
  TEMPORARY: 'temporary',
  PERMANENT: 'permanent'
};

const DEFAULT_MIN_MAX_PANE_RATIO = {
  EQUAL: 50,
  HORIZONTAL_MIN: 30,
  HORIZONTAL_MAX: 70,
  VERTICAL_MIN: 16,
  VERTICAL_MAX: 66.6
};

const PRIMARY_PANEL = {
  LEFT: 'left',
  RIGHT: 'right'
};

const RATIO_BOUNDRY = {
  MIN_BOUNDRY: 5,
  MAX_BOUNDRY: 95
};

const PIXEL_BOUNDARY = {
  MIN_PIXEL: 50,
};

const LEFT_SQUARE_BRACKET = 219;

export {
  ORIENTATION,
  SPLITSCREEN_TYPE,
  DEFAULT_MIN_MAX_PANE_RATIO,
  PRIMARY_PANEL,
  RATIO_BOUNDRY,
  PIXEL_BOUNDARY,
  LEFT_SQUARE_BRACKET
};